<template>
  <div class="detailInfo">
    <!-- 面包屑 -->
    <bread-crumb>
      <el-breadcrumb-item to="/home">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        v-if="type == 1"
        :to="{ name: 'ZhaoBiaoDaiLi', query: { type: type } }"
        >招标信息</el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-if="type == 2"
        :to="{ name: 'ZhaoBiaoDaiLi', query: { type: type } }"
        >政府采购</el-breadcrumb-item
      >
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </bread-crumb>
    <div class="infoBox">
      <div class="titBox">
        <div class="tit">{{ detail.title }}</div>
        <div class="time">发布时间：{{ detail.adddate }}</div>
      </div>
      <div class="contBox" ref="contHtml" v-html="detail.fileContent"></div>
      <div v-if="gongGaoFiles.length > 0" class="file-box">
        <label class="title">公告下载：</label>
        <label
          class="file-item"
          v-for="item in gongGaoFiles"
          :key="item.UGuid"
          @click="downFile(item.VP)"
        >
          <i class="el-icon-document"></i>
          <span>{{ item.FN }}</span>
        </label>
      </div>
      <div v-if="otherFiles.length > 0" class="file-box">
        <label class="title">其他附件：</label>
        <label
          class="file-item"
          v-for="item in otherFiles"
          :key="item.UGuid"
          @click="downFile(item.VP, 'other')"
        >
          <i class="el-icon-document"></i>
          <span>{{ item.FN }}</span>
        </label>
      </div>
      <div class="bMBox">
        <button
          @click="toBM"
          class="baoMing"
          v-if="style == 'getZhaoBiaDetail' || style == 'getZiGeYuShenDetail'"
        >
        <template v-if="detail.zhaoBiaoType=='1'||detail.zhaoBiaoType=='2'">
          获取招标文件
        </template>
        <template v-else>获取采购文件</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request2";
import {
  getZhaoBiaDetail,
  getZhongBiaoJieGuoDetail,
  getZiGeYuShenDetail,
  getHouXuanRenGongShiDetail,
  getGengZhengGongGaoDetail,
  getFilesApi,
} from "@/api/index2.js";
export default {
  name: "DetailInfo",
  data() {
    return {
      detail: "",
      unitguid: "",
      type: "",
      style: "",
      gongGaoFiles: [],
      otherFiles: [],
    };
  },
  created() {
    this.unitguid = this.$route.query.unitguid;
    this.type = this.$route.query.type;
    this.style = this.$route.query.style;
    this.getDetail();
  },
  updated() {
    let doms = this.$refs.contHtml.childNodes;
    doms.forEach((element) => {
      element.style.fontSize = "16px";
      element.style.fontFamily = "sans-serif";
      element.style.margin = "5px 0";
    });
  },
  methods: {
    getDetail() {
      let unitguid = this.$route.query.unitguid;
      let style = this.$route.query.style;
      let data = {
        unitguid: unitguid,
      };
      if (style == "getZhaoBiaDetail") {
        getZhaoBiaDetail(data).then((res) => {
          if (res) {
            this.detail = res.data.obj ? res.data.obj : "";
            this.detail.title = res.data.obj ? res.data.obj.noticeName : "";
            this.detail.adddate = res.data.obj.faBuDate
              ? res.data.obj.faBuDate
              : res.data.obj.adddate;
            this.detail.fileContent = this.detail.fileContent.replace(
              /src="\/Cloud\/ReadAlOSS.aspx/g,
              `src="${this.$store.state.baseImgUrl}/Cloud/ReadAlOSS.aspx`
            );
            // 公告附件
            this.getFiles();
            //其他附件
            this.getFiles("other","GongGaoFuJian");
          }
        });
      } else if (style == "getZiGeYuShenDetail") {
        getZiGeYuShenDetail(data).then((res) => {
          if (res) {
            this.detail = res.data.obj ? res.data.obj : "";
            this.detail.title = res.data.obj ? res.data.obj.noticeName : "";
            this.detail.adddate = res.data.obj.faBuDate
              ? res.data.obj.faBuDate
              : res.data.obj.adddate;
            this.detail.fileContent = this.detail.fileContent.replace(
              /src="\/Cloud\/ReadAlOSS.aspx/g,
              `src="${this.$store.state.baseImgUrl}/Cloud/ReadAlOSS.aspx`
            );
            // 公告附件
            this.getFiles();
          }
        });
      } else if (style == "getHouXuanRenGongShiDetail") {
        getHouXuanRenGongShiDetail(data).then((res) => {
          if (res) {
            this.detail = res.data.obj ? res.data.obj : "";
            this.detail.title = res.data.obj.gongGaoTitle;
            this.detail.adddate = res.data.obj.faBuDate
              ? res.data.obj.faBuDate
              : res.data.obj.adddate;
            this.detail.fileContent = this.detail.gongGaoContent.replace(
              /src="\/Cloud\/ReadAlOSS.aspx/g,
              `src="${this.$store.state.baseImgUrl}/Cloud/ReadAlOSS.aspx`
            );
            // 公告附件
            this.getFiles();
            //其他附件
            this.getFiles("other","otherpdf");
          }
        });
      } else if (style == "getZhongBiaoJieGuoDetail") {
        getZhongBiaoJieGuoDetail(data).then((res) => {
          if (res) {
            this.detail = res.data.obj ? res.data.obj : "";
            this.detail.title = res.data.obj.gongGaoTitle;
            this.detail.adddate = res.data.obj.faBuDate
              ? res.data.obj.faBuDate
              : res.data.obj.adddate;
            this.detail.fileContent = this.detail.gongGaoContent.replace(
              /src="\/Cloud\/ReadAlOSS.aspx/g,
              `src="${this.$store.state.baseImgUrl}/Cloud/ReadAlOSS.aspx`
            );
            // 公告附件
            this.getFiles();
            //其他附件
            this.getFiles("other","otherpdf");
          }
        });
      } else if (style == "getGengZhengGongGaoDetail") {
        getGengZhengGongGaoDetail(data).then((res) => {
          if (res) {
            this.detail = res.data.obj ? res.data.obj : "";
            this.detail.title = res.data.obj.gongGaoName;
            this.detail.adddate = res.data.obj.faBuDate
              ? res.data.obj.faBuDate
              : res.data.obj.adddate;
            this.detail.fileContent = this.detail.bianGengNeiRong.replace(
              /src="\/Cloud\/ReadAlOSS.aspx/g,
              `src="${this.$store.state.baseImgUrl}/Cloud/ReadAlOSS.aspx`
            );
            // 公告附件
            this.getFiles();
            //其他附件
            this.getFiles("other","biangenggonggao");
          }
        });
      }
    },
    toBM() {
      if (this.style == "getZhaoBiaDetail") {
        window.open(
          "https://zbt.haopan.net/web/website/zhaobiaogonggao/detail.html?unitguid=" +
            this.unitguid +
            "&projectType=" +
            this.type,
          "_blank"
        );
      } else if (this.style == "getZiGeYuShenDetail") {
        window.open(
          "https://zbt.haopan.net/web/website/zigeyushengonggao/detail.html?unitguid=" +
            this.unitguid +
            "&projectType=" +
            this.type,
          "_blank"
        );
      } else if (this.style == "getHouXuanRenGongShiDetail") {
        window.open(
          "https://zbt.haopan.net/web/website/houxuanrengongshi/detail.html?unitguid=" +
            this.unitguid +
            "&projectType=" +
            this.type,
          "_blank"
        );
      } else if (this.style == "getZhongBiaoJieGuoDetail") {
        window.open(
          "https://zbt.haopan.net/web/website/zhongbiaojieguo/detail.html?unitguid=" +
            this.unitguid +
            "&projectType=" +
            this.type,
          "_blank"
        );
      } else if (this.style == "getGengZhengGongGaoDetail") {
        window.open(
          "https://zbt.haopan.net/web/website/gengzhenggonggao/detail.html?unitguid=" +
            this.unitguid +
            "&projectType=" +
            this.type,
          "_blank"
        );
      }
    },
    // 附件
    getFiles(type,grouptype) {
      let unitguid = this.$route.query.unitguid;
      let GroupType = type == "other" ? grouptype : "signedpdf";
      let param = `Method=GetFiles&GroupGuid=${unitguid}&GroupType=${GroupType}`;
      getFilesApi(param).then((res) => {
        if (
          res.success &&
          Array.isArray(res.message) &&
          res.message.length > 0
        ) {
          if (type == "other") {
            this.otherFiles = res.message;
          } else {
            this.gongGaoFiles = res.message;
          }
        }
      });
    },
    downFile(VP, type) {
      let url = "";
      if (type == "other") {
        url = `https://zbt.haopan.net/ztbmanage/${VP}&showtype=1`;
      } else {
        url = `https://zbt.haopan.net/ztbmanage/${VP}&showtype=1&onlineshow=1`;
      }
      window.open(url);
    },
  },
};
</script>
<style scoped lang="scss">
.detailInfo {
  min-height: calc(100vh - 140px);
  .infoBox {
    width: 1200px;
    margin: 0 auto;
    .titBox {
      border-bottom: 1px solid $border-color-EBEBEB;
      text-align: center;
      padding: 26px 0 16px 0;
      .tit {
        font-size: $fonts-24;
        font-size: 30px;
        font-weight: 600;
        line-height: 40px;
        letter-spacing: 1px;
      }
      .time {
        color: $color-9;
        padding-top: 20px;
      }
    }
    .contBox {
      padding: 12px 0;
      line-height: 2;
      p {
        color: red !important;
      }
      font-size: 16px !important;
    }
    .file-box {
      font-size: 16px;
      padding: 15px 0;
      .title {
        font-weight: bolder;
      }
      .file-item {
        padding: 4px 10px;
        margin-right: 10px;
        &:hover {
          // border: 1px solid #f5f5f5;
          border-radius: 6px;
          background-color: #ebebeb;
          cursor: pointer;
        }
        span {
          margin-left: 5px;
        }
      }
      // label{
      //   border: 1px solid #f5f5f5;
      //   border-radius: 6px;
      //   padding: 8px 20px;
      //   margin-right: 10px;
      //   background-color: #f5f5f5;
      // }
    }
    .bMBox {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
      .baoMing {
        font-size: 18px;
        width: 120px;
        height: 42px;
        border-radius: 6px;
        color: #fff;
        border: 0px;
        background: #018fff;
        cursor: pointer;
      }
    }
  }
}
</style>
